import { useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../lang/en-us';
import { SubmitButton } from '../../../lib/Button';
import TextInput from '../../../lib/TextField';
import ToggleTabs, { OFF, ON } from '../../../lib/ToggleTabs';
import { sendPhoneOTP, sendEmailOTP } from '../../../redux-store/actions/nct';
import { RootStateType } from '../../../redux-store/reducers';
import { addDialCode, OTP_ACTIONS } from '../../../utils/constants';
import { ActionHeader } from '../../dashboard/makeNct';
const { dashboard, common } = en;

const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const initMessage: { error: boolean; message: string } = { error: false, message: '' };

function UpdatePan(props: any) {
    const [otpType, setOtpType] = useState(OFF);
    const switchTabs = (e: any) => setOtpType(e.target.checked ? ON : OFF);
    const [email, setEmail] = useState<string>('');
    const [emailError, setEmailerror] = useState<{ error: boolean; message: string }>(initMessage);
    const [mobile, setMobile] = useState<string>('');

    const _isSubmitDisabled = () => {
        if (otpType === 'off') {
            return mobile.length < 10;
        }
        return !(email.match(re) || []).length;
    };

    const handleSubmit = async () => {
        if (otpType === 'on' && email !== '') {
            if (email.match(re)) {
                try {
                    let res = await props.sendEmailOTP({
                        email,
                        pan: '',
                        pekrn: '',
                        action: OTP_ACTIONS.PRELOGIN_UPDATE_PAN,
                        mobile: '',
                    });
                    props.history.push('update-pan-otp', {
                        userInfo: email,
                        ...(res || {}).body,
                        isEmail: true,
                    });
                } catch (err: any) {
                    alert(err.message);
                }
            } else {
                setEmailerror({ error: true, message: common.errors.email.regex });
            }
            return;
        }
        if (otpType === 'off' && mobile !== '') {
            try {
                const { pan = '', pekrn = '' } = props;
                let response = await props.sendPhoneOTP({
                    mobile: addDialCode(mobile),
                    pan,
                    pekrn,
                    action: OTP_ACTIONS.PRELOGIN_UPDATE_PAN,
                });
                props.history.push('update-pan-otp', {
                    userInfo: mobile,
                    ...(response || {}).body,
                    isEmail: false,
                });
            } catch (e: any) {
                alert(e.message);
            }
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.UpdatePan.UpdatePanHeading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-email-img.png" alt="" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.UpdatePan.subHeading}
                            <span>{dashboard.UpdatePan.subHeadingSpan}</span>
                        </h3>
                        <p>{dashboard.UpdatePan.subHeadingInfo}</p>
                        <ToggleTabs
                            extraClass="update-pan-toggle"
                            value={otpType}
                            updateValue={switchTabs}
                            offText={dashboard.UpdatePan.verifyWithMobile}
                            onText={dashboard.UpdatePan.verifyWithEmail}
                        />
                        {otpType === OFF ? (
                            <TextInput
                                variant="outlined"
                                label={dashboard.UpdatePan.mobile}
                                value={mobile}
                                onChange={({ target: { value } }) => {
                                    (/^\d+$/.test(value) || !value) && value.length <= 10
                                        ? setMobile(value)
                                        : null;
                                }}
                            />
                        ) : (
                            <TextInput
                                variant="outlined"
                                label={dashboard.UpdatePan.email}
                                onChange={({ target: { value } }) => {
                                    setEmail(value);
                                    setEmailerror(initMessage);
                                }}
                                value={email}
                                error={emailError.error}
                                helperText={emailError.message}
                            />
                        )}
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButton
                            label={dashboard.UpdatePan.buttonText}
                            // onClick={() => props.history.push('update-pan-otp')}
                            className="customBtn"
                            disabled={_isSubmitDisabled()}
                            onClick={handleSubmit}
                        ></SubmitButton>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    sendEmailOTP,
    sendPhoneOTP,
})(UpdatePan);
